export * from './edit-acopio-dialog.component';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/edit-acopio-dialog/index.ts